// @flow

import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import React from 'react';

import PartnerQuickLinksContent from '../PartnerQuickLinksContent/PartnerQuickLinksContent';

type Props = {
  userData: ImmutablePropTypes.map.isRequired,
};

const PartnerQuickLinks = (props: Props) => {
  const lastVisitedPartnerId = props.userData.getIn([
    'data',
    '_embedded',
    'lastVisited',
    'lastVisitedPartnerId',
  ]);
  const lastVisitedPartnerName = props.userData.getIn([
    'data',
    '_embedded',
    'lastVisited',
    'lastVisitedPartnerName',
  ]);
  if (!lastVisitedPartnerId || !lastVisitedPartnerName) {
    return null;
  }
  return (
    <PartnerQuickLinksContent
      partnerId={lastVisitedPartnerId}
      partnerName={lastVisitedPartnerName}
    />
  );
};

export default PartnerQuickLinks;
